import { RouteHead } from '@/components/seo/RouteHead';
import { ROUTES } from '@/routes';
import { LegalContent } from './LegalContent';

export default function DpaPage() {
  return (
    <>
      <RouteHead
        path={ROUTES.legalDpa}
        titleKey="seo:legal_dpa.title"
        descriptionKey="seo:legal_dpa.description"
      />
      <LegalContent slug="dpa" />
    </>
  );
}
